export const compareDateIsOlder = (modificatedAt, publishedDate) => {   
    const date2 = new Date(modificatedAt);
    const date1 = new Date(publishedDate);
    const diff = date2.getTime() - date1.getTime();
    return diff > 0 ? true : false;
}